import { render, staticRenderFns } from "./CustomerAddNew.vue?vue&type=template&id=1456b07c&"
import script from "./CustomerAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports